import React, { useCallback, useMemo } from 'react';

import BaseStudentActivityCard from '@ts-core/core/components/BaseStudentActivityCard';

import { formatDateTime } from '@ts-core/core/utils/dateFormatters';

import { StudentActivity } from '../../types';

interface StudentActivityCardProps {
  activity?: StudentActivity;
  loading: boolean;

  onActivityActionClick?: (activity: StudentActivity) => void;
}

const StudentActivityCard = (props: StudentActivityCardProps) => {
  const { activity, loading, onActivityActionClick } = props;

  const handleActivityActionClick = useCallback(() => {
    if (activity && onActivityActionClick) {
      onActivityActionClick(activity);
    }
  }, [activity, onActivityActionClick]);

  const actionTitle = useMemo(() => {
    if (!activity) {
      return '';
    }
    if (activity.expired || activity.answered) {
      return 'Detalles';
    }

    return 'Hacer Tarea';
  }, [activity]);

  return (
    <BaseStudentActivityCard
      loading={loading}
      title={activity?.name}
      score={activity?.answer?.score || '-'}
      subtitle={formatDateTime(activity?.deadline)}
      onActionClick={onActivityActionClick ? handleActivityActionClick : undefined}
      actionTitle={actionTitle}
    />
  );
};

export default StudentActivityCard;
